// extracted by mini-css-extract-plugin
export default {"root":"UspMenu_root__f5h9f","menu":"UspMenu_menu__r0chQ"};